import React from 'react';
import { StyledMessage } from './styled';

const DeactivationMessage = () => {
  return (
    <StyledMessage>
      Importante: A venda do Cap Ganhador foi encerrada em 16/07/2021. Se você
      já tem um Cap Ganhador, nada muda com o seu contrato e serviços.
    </StyledMessage>
  );
};

export default DeactivationMessage;
